const CARD_ITEMS = [
  {
    tag: '悬疑',
    title: '迷雾追踪',
    desc: '高智商犯罪悬疑大片，层层反转烧脑至极，高清不卡顿沉浸式追凶体验。',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20dark%20cinematic%20scene%20with%20warm%20amber%20lighting%2C%20noir%20atmosphere%2C%20deep%20shadows%20and%20golden%20highlights%2C%20suspenseful%20film%20visual%2C%20no%20text%20no%20people%2C%20clean%20artistic%20composition&width=600&height=400&seq=card-01&orientation=landscape',
    alt: '天美影视悬疑犯罪大片迷雾追踪',
  },
  {
    tag: '爱情',
    title: '盛夏光年',
    desc: '治愈系都市爱情故事，高分口碑之作，天美影视流畅追剧陪你感受心动瞬间。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20romantic%20cinematic%20scene%20with%20soft%20golden%20sunset%20lighting%2C%20dreamy%20atmosphere%2C%20tender%20emotional%20visual%2C%20no%20text%20no%20people%2C%20clean%20artistic%20composition&width=600&height=400&seq=card-02&orientation=landscape',
    alt: '天美影视爱情电影盛夏光年',
  },
  {
    tag: '动作',
    title: '极限追击',
    desc: '燃爆肾上腺的动作巨制，震撼视效与硬核打斗，高清画质让你身临其境感受刺激。',
    image: 'https://readdy.ai/api/search-image?query=Intense%20action%20cinematic%20scene%20with%20dramatic%20red%20and%20golden%20lighting%2C%20dynamic%20energy%2C%20powerful%20visual%20impact%2C%20no%20text%20no%20people%2C%20clean%20artistic%20composition&width=600&height=400&seq=card-03&orientation=landscape',
    alt: '天美影视动作大片极限追击',
  },
  {
    tag: '喜剧',
    title: '欢乐合伙人',
    desc: '爆笑喜剧新作，轻松解压首选，天美影视不卡顿不缓冲，随时随地开怀大笑。',
    image: 'https://readdy.ai/api/search-image?query=Bright%20cheerful%20cinematic%20scene%20with%20warm%20vibrant%20lighting%2C%20playful%20atmosphere%2C%20joyful%20visual%20with%20golden%20and%20red%20tones%2C%20no%20text%20no%20people%2C%20clean%20artistic%20composition&width=600&height=400&seq=card-04&orientation=landscape',
    alt: '天美影视喜剧电影欢乐合伙人',
  },
  {
    tag: '科幻',
    title: '星际迷航记',
    desc: '国产科幻新标杆，宏大世界观与精良特效，超清画质带来震撼的太空冒险之旅。',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20cinematic%20scene%20with%20deep%20crimson%20and%20golden%20nebula%20lighting%2C%20cosmic%20atmosphere%2C%20epic%20space%20visual%2C%20no%20text%20no%20people%2C%20clean%20artistic%20composition&width=600&height=400&seq=card-05&orientation=landscape',
    alt: '天美影视科幻电影星际迷航记',
  },
  {
    tag: '古装',
    title: '长安风云录',
    desc: '匠心古装权谋大剧，服化道精美考究，流畅高清画质带你穿越盛唐感受权谋风云。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20historical%20Chinese%20cinematic%20scene%20with%20warm%20golden%20and%20red%20lighting%2C%20classical%20atmosphere%2C%20refined%20visual%20texture%2C%20no%20text%20no%20people%2C%20clean%20artistic%20composition&width=600&height=400&seq=card-06&orientation=landscape',
    alt: '天美影视古装剧长安风云录',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">热门推荐</h2>
          <p className="mt-2 text-sm text-foreground-600">精选高分影视作品，总有一部适合你</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {CARD_ITEMS.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2.5 py-0.5 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-xs text-accent-600 font-medium whitespace-nowrap">高清在线</span>
                </div>
                <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-1.5">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}